export default [
  {
    path: "*",
    name: "首页",
    component: resolve => require(["@/pages/index"], resolve)
  },
];
